import React, { Component } from 'react';
import GeoTableHeader from './GeoTableHeader';
import GeoTableRow from './GeoTableRow';
import GeoTableSummary from './GeoTableSummary';
import BaseDataTable from '../../../BaseDataTable';
import styles from './styles.scss';
import { arrayOf, object, objectOf, number, shape, string, func, bool } from 'prop-types';
import { GEO_TABLE_TITLE } from '../constants';
import { CircularProgress } from '@material-ui/core';
import { get } from 'lodash';
import { GEO_CHART_ID } from '../../../../helpers/constant';

export default class GeoTable extends Component {
  static propTypes = {
    data: arrayOf(object),
    campaign: objectOf(object),
    initialSortStatus: shape({
      sortKey: string,
      sortType: string
    }),
    onCellClick: func,
    inpdf: bool,
    page: number,
    rowsPerPage: number,
    isGrandTotalDisplay: bool,
    isAvgCostDisabled: bool,
    uniqueAds: number,
    isLoading: bool,
    summaryAllData: arrayOf(object),
    isCustomReport: bool,
    itemIndex: number
  };

  static defaultProps = {
    data: [],
    initialSortStatus: { sortKey: 'visitsOfAds', sortType: 'desc' }
  };

  generateHeaders() {
    const { campaign, isAvgCostDisabled, data } = this.props;
    const { geoType } = campaign;
    const locationTitle = get(data, '0.type', GEO_TABLE_TITLE[geoType]) || 'Location';
    const headers = [
      {title: locationTitle, key: 'name'},
      {title: 'Ad Visits', key: 'visits'},
      {title: 'Ads', key: 'ads'},
      {title: 'Ad Visits/Ads', key: 'visitsOfAds'}
    ];
    !isAvgCostDisabled && headers.push({ title: 'Avg. Ad Cost', key: 'avgAdCost' });
    return headers;
  };

  prepSummaryData() {
    const { summaryAllData = [], uniqueAds  } = this.props;
    const summaryData = summaryAllData.reduce((accumulator, entry) => {
      const { visits, ads, totalAdCost, pricedAds } = entry;
      accumulator.totalAds += ads || 0;
      accumulator.totalAdVisits += visits || 0;
      accumulator.totalAdCost += totalAdCost || 0; 
      accumulator.numPricedAds += pricedAds || 0;
      return accumulator;
    }, {
      totalAds: 0, 
      totalAdVisits: 0,
      numPricedAds: 0,
      totalAdCost: 0,
      uniqueAds
    });
    return summaryData;
  }

  render() {
    const { 
      data, 
      initialSortStatus, 
      onCellClick,
      inpdf, 
      page, 
      rowsPerPage, 
      isGrandTotalDisplay, 
      isAvgCostDisabled,
      isLoading,
      isCustomReport,
      itemIndex
    } = this.props;

    const summaryData = this.prepSummaryData();
    const headers = this.generateHeaders();

    return(
      <div data-test="locationTable" className={styles.tableContainer}>
        { isLoading &&
          <div className={styles.loadingSpinner}>
            <CircularProgress size={100} thickness={1}/>
          </div>
        }
        <BaseDataTable
          data={data}
          tableHead={<GeoTableHeader headers={headers} />}
          tableRow={
            <GeoTableRow
              isAvgCostDisabled={isAvgCostDisabled}
              data={data}
              onClick={onCellClick}
              isCustomReport={isCustomReport}
            />
          }
          tableSummary={<GeoTableSummary summaryData={summaryData} isAvgCostDisabled={isAvgCostDisabled} />}
          initialSortStatus={initialSortStatus}
          pagination
          inpdf={inpdf}
          page={page}
          rowsPerPage={rowsPerPage}
          isGrandTotalDisplay={isGrandTotalDisplay}
          tableId={GEO_CHART_ID}
          tableIndex={itemIndex}
          isCustomReport={isCustomReport}
        />
      </div>
    )
  };
};
